import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CalendarDays, Info } from 'lucide-react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { GcalStatusBadge, connectGoogleCalendar, useGcalReturnToast } from './BookingLinkPanel';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const GoogleCalendarConnections = () => {
  const [data, setData] = useState(null);
  useGcalReturnToast();
  useEffect(() => { axios.get(`${API}/admin/google-calendar/connections`).then((r) => setData(r.data)).catch(() => setData({ interviewers: [] })); }, []);
  if (!data) return null;
  return (
    <Card className="p-5 space-y-3" data-testid="gcal-connections-card">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <h3 className="font-semibold flex items-center gap-2"><CalendarDays size={18} className="text-primary" /> Google Calendar (interviewers)</h3>
        {data.sandbox && <span className="text-[11px] rounded-full bg-amber-100 text-amber-800 px-2 py-0.5" data-testid="gcal-sandbox-badge">Preview: Google & email are simulated</span>}
      </div>
      <div className="space-y-2">
        {data.interviewers.map((i) => (
          <div key={i.personnel_id} className="flex flex-wrap items-center justify-between gap-2 border rounded-md p-2.5" data-testid={`gcal-row-${i.personnel_id}`}>
            <div>
              <p className="text-sm font-medium">{i.name}</p>
              <GcalStatusBadge status={i.google_calendar} testId={`gcal-int-status-${i.personnel_id}`} />
            </div>
            <Button size="sm" variant="outline" onClick={() => connectGoogleCalendar(i.personnel_id)} data-testid={`gcal-int-connect-${i.personnel_id}`}>
              {i.google_calendar.connected ? 'Reconnect' : 'Connect'}
            </Button>
          </div>
        ))}
        {data.interviewers.length === 0 && <p className="text-sm text-muted-foreground">No interviewers yet. Flag people under Careers → Interviewers.</p>}
      </div>
      {data.redirect_uri && (
        <p className="text-xs text-muted-foreground flex items-start gap-1.5"><Info size={13} className="mt-0.5 shrink-0" />
          <span>Google Cloud redirect URI: <code>{data.redirect_uri}</code></span>
        </p>
      )}
    </Card>
  );
};
